import { AfterViewInit, Directive, ElementRef, HostListener, OnInit } from '@angular/core';

/**
 * Ajusta la altura del elemento hasta el borde inferior de la ventana midiendo su posición real,
 * en vez de restar un offset de píxeles adivinado para el header (antes calc(100vh - 87px)): si el
 * header real mide menos que eso, sobra una franja vacía debajo de la página.
 */
@Directive({
  selector: '[appFitViewport]'
})
export class FitViewportDirective implements OnInit, AfterViewInit {
  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    // Respaldo hasta medir: con overflow:hidden, sin altura el contenedor colapsaría y ocultaría la página.
    if (!this.el.nativeElement.style.height) {
      this.el.nativeElement.style.height = '100dvh';
    }
  }

  ngAfterViewInit(): void {
    // Doble rAF: justo tras ngAfterViewInit (sobre todo en navegación SPA) el layout puede no estar
    // asentado y getBoundingClientRect().top leería un valor desactualizado.
    requestAnimationFrame(() => requestAnimationFrame(() => this.sync()));
  }

  @HostListener('window:resize')
  sync(): void {
    const el = this.el.nativeElement;
    const top = el.getBoundingClientRect().top;
    // Medición fuera de rango = layout aún no asentado: se mantiene la altura actual.
    if (top > 0 && top < window.innerHeight) {
      el.style.height = `calc(100dvh - ${Math.round(top)}px)`;
    }
  }
}
